module.exports = __webpack_public_path__ + "static/media/1.c80e7cc3.webp";